// Sitenin giriş bölümlerinde kullanılan kampüs videosu.
// Orijinal dosya (fenfakultesivideo.mp4) 28 MB; burada ekrana ve bağlantıya
// uygun sıkıştırılmış sürüm seçilir.
//
// Video, sayfa yüklenene kadar indirilmez: önce kapak görseli (15 KB) görünür,
// sayfa hazır olunca video başlar. Böylece video, sayfanın JavaScript'i ile
// bant genişliği için yarışmaz. Bileşenler `src` yerine `data-src` verir;
// aşağıdaki activateDeferredVideos() gerçek kaynağı sonradan bağlar.

export const HERO_POSTER = '/fenfakultesivideo-poster.webp';

function pickVideo() {
  if (typeof window === 'undefined') return null;
  try {
    // Veri tasarrufu modu: video indirme, kapak görseli yeter
    if (navigator.connection?.saveData) return null;
    // Hareket hassasiyeti (işletim sistemi ayarı)
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return null;
    // Erişilebilirlik menüsünde "Animasyonları durdur" seçili
    const a11y = JSON.parse(localStorage.getItem('ff-a11y-settings') || '{}');
    if (a11y.stopAnimations) return null;
  } catch { /* yok say */ }
  return window.innerWidth < 768 ? '/fenfakultesivideo-480.mp4' : '/fenfakultesivideo-720.mp4';
}

// null ise video yüklenmez, sadece kapak görseli görünür
export const HERO_VIDEO = pickVideo();

// Not: kaynak <video data-src> üzerinde olmalı. <source> etiketi src'siz
// bırakılırsa tarayıcı "error" olayı tetikler.
function attach(video) {
  const src = video.getAttribute('data-src');
  if (!src) return;
  video.removeAttribute('data-src');
  video.muted = true; // otomatik oynatma için şart (React muted'ı öznitelik olarak yazmıyor)
  video.src = src;
  if (video.autoplay) video.play?.().catch(() => {});
}

// index.js'ten bir kez çağrılır
export function activateDeferredVideos() {
  if (typeof window === 'undefined' || !HERO_VIDEO) return;
  const start = () => {
    document.querySelectorAll('video[data-src]').forEach(attach);
    // Sonradan açılan sayfalardaki videolar (SPA geçişleri) hemen bağlanır
    new MutationObserver(muts => {
      for (const m of muts) for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches?.('video[data-src]')) attach(n);
        n.querySelectorAll?.('video[data-src]').forEach(attach);
      }
    }).observe(document.body, { childList: true, subtree: true });
  };
  const later = () => (window.requestIdleCallback ? requestIdleCallback(start, { timeout: 2000 }) : setTimeout(start, 500));
  if (document.readyState === 'complete') later();
  else window.addEventListener('load', later, { once: true });
}
